'use client';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import * as React from 'react';
import { TabsOwnProps } from '@mui/material/Tabs/Tabs';

type StyledTabsProps = TabsOwnProps;

interface StyledTabProps {
    label: React.ReactNode;
    isFaulty?: boolean;
}

export const StyledTabs = styled((props: StyledTabsProps) => {
    const children =
        props.children instanceof Array ? props.children : [props.children];

    return (
        // @ts-ignore
        <Tabs
            {...props}
            component="div"
            TabIndicatorProps={{
                className: 'MuiTabs-indicatorSpan',
                style: {
                    backgroundColor: children[props.value]?.props?.isFaulty
                        ? '#DC6803'
                        : '#009B5D',
                },
            }}
        />
    );
})(() => {
    return {
        borderBottom: '1px solid #EAECF0',
        '& .MuiTabs-indicator': {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
        },
        '& .MuiTabs-indicatorSpan': {
            width: '100%',
            backgroundColor: '#009B5D',
        },
    };
});

export const StyledTab = styled((props: StyledTabProps) => (
    //@ts-ignore
    <Tab disableRipple {...props} />
))(props => {
    return {
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '14px',
        fontFamily: 'inherit',
        // marginRight: theme.spacing(1),
        color: '#667085',

        '&.Mui-selected': {
            color: props.isFaulty ? '#DC6803' : '#009B5D',
        },
        '&.Mui-focusVisible': {
            backgroundColor: 'rgba(100, 95, 228, 0.32)',
        },
    };
});
